/*
 * @Author: your name
 * @Date: 2020-10-28 17:45:55
 * @LastEditTime: 2021-11-22 15:04:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ksh-factory-vue/src/store/module/common/action.js
 */
import * as Types from '../../mutations-types'
import * as IndexService from '@/services/indexService'
export default {
  getIndexDemandList ({commit, state}) {
    return IndexService.getIndexDemandList().then(res=>{
      commit(Types.GET_INDEX_DEMAND_LIST,res.data)
      return Promise.resolve(res)
    },rea=>{
      return Promise.reject(rea)
    })
  }
}